module.exports = __webpack_public_path__ + "img/insight--icon.0e12a403.svg";